import type { Screenshot } from 'types';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

type ScreenshotDialogProps = {
  screenshot: Screenshot;
  imageSrc: string;
  onClose: () => void;
};

export const ScreenshotDialog = ({ screenshot, imageSrc, onClose }: ScreenshotDialogProps) => {
  const onDownload = () => {
    const link = document.createElement('a');
    link.href = imageSrc;
    link.download = `screenshot-${screenshot.id}.png`;
    link.click();
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="border-line bg-panel sm:rounded-panel flex h-[90vh] max-w-[90vw] flex-col overflow-hidden p-0">
        <div className="flex min-h-0 flex-1 items-center justify-center p-4">
          <img
            src={imageSrc}
            alt={screenshot.comment || 'Screenshot'}
            className="max-h-full max-w-full object-contain"
          />
        </div>
        <div className="border-line flex items-center justify-between gap-3 border-t px-4 py-3">
          <p className="supporting min-w-0 flex-1 truncate">{screenshot.comment || ''}</p>
          <Button
            variant="outline"
            size="sm"
            onClick={onDownload}
            className="border-line text-foreground hover:bg-hover h-8 shrink-0 rounded-lg border bg-transparent px-3 text-meta"
          >
            <Download className="size-3.5" strokeWidth={1.5} />
            Download
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
